import React, {Component} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';


var moment = require('moment');


class Staking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().add(28, 'days').hours(24).minutes(0).seconds(0).local().toDate(),
            endSupply: '',
            minDate: moment().add(28, 'days').hours(24).minutes(0).seconds(0).local().toDate(),
            p3xToStake: ''
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleP3XToStakeChange = this.handleP3XToStakeChange.bind(this);
        this.handleEndSupplyChange = this.handleEndSupplyChange.bind(this);
        this.handleStakeTimeGauntlet = this.handleStakeTimeGauntlet.bind(this);
        this.handleStakeSupplyGauntlet = this.handleStakeSupplyGauntlet.bind(this);
    }

    async componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            if (this.props.data.P3DTokenContract !== null) {
                let val = this.props.data.gauntletMinimumSupply;
                this.setState({
                    endSupply: val
                });
            }
        }
    }

    handleDateChange(date) {
        this.setState({
            date: date
        });
    }

    handleP3XToStakeChange(event) {
        let val = event.target.value;
        this.setState({
            p3xToStake: val
        });
    }

    handleEndSupplyChange(event) {
        let val = event.target.value;
        this.setState({
            endSupply: val
        });
    }

    async handleStakeTimeGauntlet() {
        let dt = this.state.date;
        if (!moment(dt).isValid()) {
            toast.error(this.props.data.txtResponse.acquiredTimeGauntlet.dateIsValidErr);
            console.log(this.props.data.txtResponse.acquiredTimeGauntlet.dateIsValidErr);
            return;
        }
        let ts = moment(dt).unix();
        let amt = this.state.p3xToStake;
        if (parseFloat(amt) > parseFloat(this.props.data.balanceOf)) {
            toast.error(this.props.data.txtResponse.acquiredTimeGauntlet.balanceOfErr);
            console.log(this.props.data.txtResponse.acquiredTimeGauntlet.balanceOfErr);
            return;
        }

        if (parseFloat(amt) <= 0 || amt==='') {
            toast.error(this.props.data.txtResponse.acquiredTimeGauntlet.amtErr);
            console.log(this.props.data.txtResponse.acquiredTimeGauntlet.amtErr);
            return;
        }
        try {
            await this.props.data.P3XTokenContract.methods.acquireGauntlet(this.props.data.web3.utils.toWei(amt, "ether"), 1, ts).send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.acquiredTimeGauntlet.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    async handleStakeSupplyGauntlet() {
        let supply = this.props.data.web3.utils.toWei(this.state.endSupply, "ether");
        let amt = this.state.p3xToStake;

        if (supply <= 0) {
            toast.error(this.props.data.txtResponse.acquiredSupplyGauntlet.supplyErr);
            console.log(this.props.data.txtResponse.acquiredSupplyGauntlet.supplyErr);
            return;
        }
        if (parseFloat(amt) > parseFloat(this.props.data.balanceOf)) {
            toast.error(this.props.data.txtResponse.acquiredSupplyGauntlet.balanceOfErr);
            console.log(this.props.data.txtResponse.acquiredSupplyGauntlet.balanceOfErr);
            return;
        }
        if (amt <= 0 || amt==='') {
            toast.error(this.props.data.txtResponse.acquiredSupplyGauntlet.amtErr);
            console.log(this.props.data.txtResponse.acquiredSupplyGauntlet.amtErr);
            return;
        }
        try {
            await this.props.data.P3XTokenContract.methods.acquireGauntlet(this.props.data.web3.utils.toWei(amt, "ether"), 2, supply).send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.acquiredSupplyGauntlet.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    render() {
        return (

            <div className="row">
                <div className="col-12 mt-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                                    <div className="text-center">
                                        <h5 className="card-title" style={{display: 'inline-block', paddingLeft: '55px', textAlign: 'center'}}>
                                            Acquire Staking Gauntlet
                                        </h5>
                                        {/*<a href="#" onClick="return false;" style={{fontSize:'16px', float:'right', fontWeight:'normal'}} data-toggle="modal" data-target="#modal-gauntlet-details">*/}
                                        {/*<i className="far fa-question-circle"></i>*/}
                                        {/*</a>*/}
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-12 text-center">
                                            <ul className="gauntlet-tabs nav nav-pills nav-justified text-center" role="tablist">
                                                <li className="nav-item">
                                                    <a className="nav-link active" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true"> Time Based </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">P3D Supply Based</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                            <div className="form-group row">
                                                <div className="col-12 text-right">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">P3X to Stake:</div>
                                                        </div>
                                                        <input id="time-based-gauntlet-amount" type="text" className="form-control" value={this.state.p3xToStake}
                                                               onChange={this.handleP3XToStakeChange}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12 text-left">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">End Date:</div>
                                                        </div>
                                                        <DatePicker
                                                            className="form-control text-left datepicker-radius-fix"
                                                            selected={this.state.date}
                                                            onChange={this.handleDateChange}
                                                            showTimeSelect
                                                            minDate={this.state.minDate}
                                                            timeIntervals={15}
                                                            dateFormat="MMMM d, yyyy"
                                                            timeCaption="time"
                                                            placeholderText="Click to select a date"
                                                        />
                                                    </div>
                                                    <div id="txt-must-stake-until" className="text-muted" style={{fontSize: '12px'}}>{this.props.data.gauntletMustStakeUntil}</div>
                                                </div>
                                            </div>

                                            <button type="button" id="time-based-gauntlet-acquire" className="btn btn-primary btn-block" onClick={this.handleStakeTimeGauntlet}>Stake Gauntlet</button>
                                        </div>
                                        <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                            <div className="form-group row">
                                                <div className="col-12 text-right">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">P3X to Stake:</div>
                                                        </div>
                                                        <input id="supply-based-gauntlet-amount" type="text" className="form-control" value={this.state.p3xToStake}
                                                               onChange={this.handleP3XToStakeChange}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12 text-left">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">End Supply:</div>
                                                        </div>
                                                        <input id="supply-based-gauntlet-supply" type="text" className="form-control" onChange={this.handleEndSupplyChange}
                                                               value={this.state.endSupply}/>
                                                    </div>
                                                    <div id="txt-minimum-supply" className="text-muted" style={{fontSize: '12px'}}>Minimum Supply: {this.props.data.gauntletMinimumSupply_Display} P3D
                                                    </div>
                                                </div>
                                            </div>

                                            <button type="button" id="supply-based-gauntlet-acquire" className="btn btn-primary btn-block" onClick={this.handleStakeSupplyGauntlet}>Stake Gauntlet
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                                    <div className="text-center">
                                        <h5 className="card-title" style={{display: 'inline-block', paddingLeft: '55px', textAlign: 'center'}}>
                                            Current Gauntlet
                                        </h5>
                                        {/*<a href="#" onClick="return false;" style={{fontSize:'16px', float:'right', fontWeight:'normal'}} data-toggle="modal" data-target="#modal-gauntlet-upgrade">*/}
                                        {/*<i className="far fa-question-circle"></i>*/}
                                        {/*</a>*/}
                                    </div>
                                    <div className="row">
                                        <label className="col-5 col-form-label">Gauntlet Type:</label>
                                        <p id="current-gauntlet-type" className="col-7 text-right"
                                           style={{fontSize: '18px', marginBottom: '0', color: 'var(--primary)'}}>{this.props.data.gauntletType}</p>
                                    </div>
                                    <div className="row">
                                        <label id="current-gauntlet-end" className="col-5 col-form-label">{this.props.data.gauntletEndText}</label>
                                        <p id="current-gauntlet-time" className="col-7 text-right"
                                           style={{fontSize: '18px', marginBottom: '0', color: 'var(--primary)'}}>{this.props.data.gauntletEndDateOrSupply}</p>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <table className="mt-2" style={{width: '100%', textAlign: 'center', color: 'inherit'}}>
                                                <tbody>
                                                <tr style={{borderBottom: '1px solid #1c1a1a'}}>
                                                    <td colSpan="3">
                                                        Gauntlet Amount
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div id="current-gauntlet-amount"
                                                             style={{height: '23px', fontSize: '18px', color: 'var(--primary)'}}>{this.props.data.totalGauntletP3XAmt} P3X
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div id="current-gauntlet-amount-eth"
                                                             style={{height: '23px', fontSize: '18px', color: 'var(--primary)'}}>{this.props.data.totalGauntletEthAmt_Display} ETH
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div id="current-gauntlet-amount-fiat"
                                                             style={{height: '23px', fontSize: '18px', color: 'var(--primary)'}}>{this.props.data.fiatGauntlet} {this.props.data.currency}</div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div style={{fontSize: '13px', marginTop: '20px'}}>The staked P3X will be unlocked when the Gauntlet End value is reached. <br/>Go long and become a
                                                Gauntlet Legend!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer/>
            </div>

        );
    }
}

export default Staking;